import React from 'react';

interface Tab {
  key: string;
  label: string;
  icon?: string;
}

interface TabNavigationProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabKey: string) => void;
  className?: string;
}

const TabNavigation: React.FC<TabNavigationProps> = ({
  tabs,
  activeTab,
  onTabChange,
  className = ''
}) => {
  return (
    <nav className={`flex space-x-1 ${className}`}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => onTabChange(tab.key)}
          disabled={activeTab === tab.key} // Aktif tab'ı disable et
          className={`
            flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors
            ${activeTab === tab.key
              ? 'bg-cafe-brown dark:bg-cafe-dark text-white cursor-default'
              : 'text-gray-600 dark:text-dark-text hover:text-gray-900 dark:hover:text-dark-text hover:bg-gray-100 dark:hover:bg-dark-surface cursor-pointer'
            }
          `}
        >
          {tab.icon && <span className="mr-2">{tab.icon}</span>}
          {tab.label}
        </button>
      ))}
    </nav>
  );
};

export default TabNavigation;
